import type { components } from '@/generated/internal-api/openapi-types';

export type ExportV1 = components['schemas']['ExportV1.schema'];
export type ExportApiId = components['schemas']['ExportApiId.schema'];
export type ExportType = components['schemas']['ExportType.schema'];
export type StudyReportSubType = components['schemas']['StudyReportSubType.schema'];

export const ExportTypeValue = {
  observation: 'observation',
  audit: 'audit',
  study_report: 'study_report',
  recaging: 'recaging',
  randomization: 'randomization',
  datatable: 'datatable',
  sample: 'sample',
} as const satisfies Record<ExportType, ExportType>;

export const STATUS_LABEL: Record<ExportV1['status'], string> = {
  in_progress: 'In progress',
  completed: 'Completed',
  failed: 'Failed',
};

export const TYPE_LABEL: Record<ExportType, string> = {
  [ExportTypeValue.observation]: 'Observation',
  [ExportTypeValue.audit]: 'Audit log',
  [ExportTypeValue.study_report]: 'Study report',
  [ExportTypeValue.recaging]: 'Recaging report',
  [ExportTypeValue.randomization]: 'Randomization',
  [ExportTypeValue.datatable]: 'Datatable',
  [ExportTypeValue.sample]: 'Samples',
};

export const SUB_TYPE_LABEL: Record<StudyReportSubType, string> = {
  study_data: 'Study data',
  groups: 'Groups',
  prism: 'Prism',
  dosing: 'Dosing',
};
